import React from "react";
import styled, { css } from "styled-components";

import { StyledButton } from "./Button";

const StyledCancelButton = styled(StyledButton)`
  ${({ theme: { mobile } }) =>
    !mobile &&
    css`
      @media (max-width: 1350px) {
        width: 100%;
        font-size: 12px;
      }
    `}
`;

export function CancelButton({ ...props }) {
  return <StyledCancelButton {...props}>Cancel</StyledCancelButton>;
}
